import "./App.css";
import React from "react";
import json from "./Videos/Components/json";
import VideoPlayer from "./Videos/Components/Video";

const ArrowTurnBackwardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={32}
    height={32}
    color={"#FFFFFF"}
    fill={"none"}
    {...props}
  >
    <path
      d="M11 6H15.5C17.9853 6 20 8.01472 20 10.5C20 12.9853 17.9853 15 15.5 15H4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99998 12C6.99998 12 4.00001 14.2095 4 15C3.99999 15.7906 7 18 7 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Task01Icon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#FFFFFF"} fill={"none"} {...props}>
    <path d="M7.99805 16H11.998M7.99805 11H15.998" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836L3.49609 15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22L14.4961 22C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

function App() {

  return (
    <div className="container">
      <div className="background">
        <img
          src="https://naturespath.com/cdn/shop/articles/soil-and-dirt.jpg?v=1639150256"
          alt="background"
        />
      </div>
      <div className="titulo">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSd7ecoqo1zurZQaaPM8XRElwcdhE6ocAvE031f7QgvAXsey8A/viewform"> <Task01Icon/> <h3>Envia tu video!</h3> </a>
        <h1>#acariciarlatierra</h1>
      </div>
      <div className="videos__container">
        {json.map((video) => (
          <VideoPlayer key={video} src={video} />
        ))}
      </div>
      <div className="sendVideo">
        <a href="https://modulattions.wixsite.com/proyecto-humano---ti/about-3">
          <ArrowTurnBackwardIcon/>
        </a>
      </div>
    </div>
  );
}

export default App;
